import { Injectable } from '@angular/core';
import { Location } from './location.model';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  locationData :Location;

  constructor(private firestore:AngularFirestore) { }

  getLocations(){
    return this.firestore.collection('location').snapshotChanges();
  }

  getLocation(){
    return this.firestore.collection('location', x => x.orderBy('name', 'asc')).snapshotChanges();
  }
}
